export default __webpack_public_path__ + "static/media/africa.0b452f0f.png";